// Componentes nativos
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Modal from "react-modal";

// Componentes personalizados
import Header from "../../Header";

// Executa a folha de estilos própia
import "./style.css";

// Ícones
import { IoMdArrowRoundBack } from "react-icons/io";

// Classes de controle e interfaces
import Tabela, { Organizacao } from "../Core/TabelaPeriodica";
import ElementoQuimico from "../Core/interfaces/ElementoQuimico";

// Funções de formatação
import { massaMolar, distribuicao } from "../../../utils/formatar";

export default function TabelaPeriodica() {
    // Gerencia a navegação
    const nav = useHistory();
    function back() {
        nav.goBack();
    }

    // Gerencia informações do modal
    const [aberto, setAberto] = useState(false);
    const [selecionado, setSelecionado] = useState<ElementoQuimico>();
    const [numeroAtomico, setNumeroAtomico] = useState(0);

    // Gerencia informações dos elementos
    const [carregado, setCarregado] = useState(false);
    const [periodicTable, setPeriodicTable] = useState<Organizacao>();
    const [elementos, setElementos] = useState<ElementoQuimico[]>([]);

    // Função para preenchimento do modal de informações
    function detalhar(z: number) {
        setSelecionado(elementos[z - 1]);
        setNumeroAtomico(z);
        setAberto(true);
    }

    // Função de inicialização
    function init() {
        setPeriodicTable(Tabela.getTabela());
        setElementos(Tabela.getAll());
        setCarregado(true);
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">

                    <div className="linha-titulo">
                        <h3>Tabela Periódica Interativa</h3>

                        <div className="botao-icone" onClick={back}>
                            <IoMdArrowRoundBack size={20} />
                            <span>Voltar</span>
                        </div>
                    </div>

                    <div className="linha-nivel">
                        <span className="nivel"><strong>Nível</strong>: Introdutório</span>
                    </div>

                    <p>Nesta página você podera interagir com uma tabela periódica. Selecione um elemento químico para ver mais informações sobre ele.</p>

                    {carregado && <div className="area-tp">
                        {periodicTable?.periodos.map((item, indc) => (
                            <div className="periodo-tp" key={`periodo${indc +1}`}>
                                {item.map((el, jel) => (
                                    <div className={`elemento-tp ${el.existe ? "": "none"}`} key={`el${el.z}${jel}`} onClick={() => detalhar(el.z)}>
                                        <span className="z-tp">{el.z}</span>
                                        <span className="s-tp">{el.elemento.simbolo}</span>
                                    </div>
                                ))}
                            </div>
                        ))}

                        <p>Família dos Lantanídeos</p>
                        <div className="periodo-tp" key="lanta">
                            {periodicTable?.lantanideos.map((lant, ilant) => (
                                <div className={`elemento-tp ${lant.existe ? "": "none"}`} key={`lant${ilant}`} onClick={() => detalhar(lant.z)}>
                                    <span className="z-tp">{lant.z}</span>
                                    <span className="s-tp">{lant.elemento.simbolo}</span>
                                </div>
                            ))}
                        </div>

                        <p>Família dos Actinídeos</p>
                        <div className="periodo-tp" key="act">
                            {periodicTable?.actinideos.map((act, iact) => (
                                <div className={`elemento-tp ${act.existe ? "": "none"}`} key={`act${iact}`} onClick={() => detalhar(act.z)}>
                                    <span className="z-tp">{act.z}</span>
                                    <span className="s-tp">{act.elemento.simbolo}</span>
                                </div>
                            ))}
                        </div>

                    </div>}

                </div>
            </div>

            <Modal ariaHideApp={false} isOpen={aberto} style={modalStyles} onRequestClose={() => setAberto(false)}>
                <p><b>Nome</b>: {selecionado?.nome}</p>
                <p><b>Símbolo</b>: {selecionado?.simbolo}</p>
                <p><b>Massa Molar</b>: {massaMolar(Number(selecionado?.massaMolar))}</p>
                <p><b>Distribuição Eletrônica</b>: {distribuicao(numeroAtomico)}</p>
            </Modal>

        </div>
    );
}

const modalStyles = {
    overlay: {
        backgroundColor: "rgba(250,250,250,0.8)"
    },
    content: {
        backgroundColor: "#f0f0f5",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: 600,
        width: "90%",
        borderRadius: 10
    }
};